import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'
import { DndProvider } from 'react-dnd'
import { hot } from 'react-hot-loader/root'

import HTML5Backend from 'react-dnd-html5-backend'
import Routes from 'routes'
import { measureTimingStart } from 'data/metrics'
import ErrorBoundary from 'components/Utils/ErrorBoundary'

class Root extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    measureTimingStart('TIME_TO_AUTH')
    measureTimingStart('TIME_TO_LOAD_APP')
    measureTimingStart('TIME_TO_LOAD_FIRST_NOTE')
  }

  render() {
    const { store, history } = this.props
    return (
      <ErrorBoundary store={store}>
        <Provider store={store}>
          <DndProvider backend={HTML5Backend}>
            <Router history={history}>
              <Routes />
            </Router>
          </DndProvider>
        </Provider>
      </ErrorBoundary>
    )
  }
}

export default hot(Root)
